var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExperiment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1757480904158,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 29741,
    width: 14,
    height: 14,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M557.6 513.142857c22.4 0 41.028571-16.228571 44.914286-37.485714A45.737143 45.737143 0 0 1 557.714286 512a45.714286 45.714286 0 0 1-45.714286-45.028571v0.571428c0 25.142857 20.457143 45.6 45.6 45.6zM786.285714 712.914286l-0.342857-0.342857c-33.142857-20-71.2-30.628571-110.857143-30.628572-51.314286 0-99.657143 17.942857-138.285714 50.057143a292.88 292.88 0 0 1-188.457143 68.457143c-47.085714 0-92.571429-11.2-133.371428-32L167.428571 891.428571h689.142858l-68.457143-177.371428-1.828572-1.142857z",
    fill: "#4b5563",
    "p-id": 29742
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M931.428571 869.6L722.628571 329.142857V130.285714H804.571429v-77.714285H219.428571v77.714285h81.942858v198.857143L92.571429 869.6c-3.2 8.457143-4.914286 17.371429-4.914286 26.4 0 40.342857 32.8 73.142857 73.142857 73.142857h702.4c9.028571 0 17.942857-1.714286 26.4-4.914286 37.714286-14.514286 56.457143-56.914286 41.828571-94.628571zM379.085714 343.657143V132.571429h265.828572v211.085714L748.8 612.571429c-23.657143-6.057143-48.114286-9.142857-73.028571-9.142858-69.942857 0-136.228571 24.571429-188.914286 68.571429a215.748571 215.748571 0 0 1-138.628572 50.171429c-37.371429 0-73.257143-9.485714-104.914285-27.085715l135.771428-351.428571zM167.428571 891.428571l47.542858-122.971428 0.114285-0.228572c40.8 20.685714 86.171429 31.771429 133.257143 31.771429 69.942857 0 136.228571-24.571429 188.914286-68.571429 38.742857-32.228571 87.2-50.171429 138.628571-50.171428 40 0 78.171429 10.857143 111.542857 30.971428l0.685715 1.828572L856.571429 891.428571h-689.142858z",
    "p-id": 29743,
    fill: "#4b5563"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M557.714286 512c22.057143 0 40.457143-15.542857 44.8-36.342857 0.685714-3.085714 0.914286-6.171429 0.914285-9.371429 0-25.257143-20.457143-45.714286-45.714285-45.714285s-45.714286 20.457143-45.714286 45.714285v0.685715a45.714286 45.714286 0 0 0 45.714286 45.028571z",
    "p-id": 29744,
    fill: "#4b5563"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperiment);
export default __webpack_public_path__ + "static/media/experiment.28c177d1.svg";
export { ForwardRef as ReactComponent };